export const taxis = [
  {
    id: 1,
    model: 'Toyota RAV4 Basis',
    price: 170000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/rav4basisnew.webp',
    slug: 'toyota-rav4-basic',
    explanation: 'הבחירה החכמה למונית מודרנית\nטויוטה RAV4 בגרסת הבסיס מציעה שילוב מנצח בין נוחות, בטיחות וחסכון. מנוע 2.0 ליטר בנזין חזק עם תיבת הילוכים אוטומטית רציפה (CVT), המספק כ-173 כוחות סוס. רכב פנאי (SUV) מרווח ונעים לנהיגה עירונית ובינעירונית, עם צריכת דלק חסכונית (כ-14 ק"מ לליטר). תא מטען נדיב, מערכת מולטימדיה מקורית עם מסך מגע, קישוריות Apple CarPlay ו-Android Auto. מערכות בטיחות מתקדמות Toyota Safety Sense כולל בלימת חירום אוטונומית, בקרת סטייה מנתיב ועוד. אידיאלי לנהגי מוניות שמחפשים נוחות ותדמית יוקרתית.'
  },
  {
    id: 2,
    model: 'Toyota RAV4 Pro',
    price: 190000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/rav4c.png',
    slug: 'toyota-rav4-pro',
    explanation: 'מונית היברידית ברמה אחרת\nגרסת הפרו של ה-RAV4 מציגה מנוע היברידי בנפח 2.5 ליטר עם הספק של כ-218 כ"ס ושילוב מושלם בין ביצועים ויעילות. חסכון יוצא דופן בדלק (עד 20 ק"מ לליטר), נהיגה שקטה וחלקה, תא נוסעים איכותי ומאובזר, כולל גג שמש פנורמי, מושבים חשמליים, מצלמות היקפיות וחיישנים. מושלם למוניות VIP, נסיעות נוחות באזורים עירוניים ובין-עירוניים, ומראה עוצמתי שמקרין אמינות ויוקרה.'
  },
  {
    id: 3,
    model: 'Toyota Corolla Sedan',
    price: 120000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/sedanc.png',
    slug: 'toyota-corolla-sedan',
    explanation: 'הקלאסיקה שתמיד מנצחת\nהטויוטה קורולה סדאן – הבחירה הקלאסית והאהובה על נהגי מוניות. מנוע בנזין 1.6 ליטר חסכוני במיוחד (כ-17 ק"מ לליטר), תיבת הילוכים אוטומטית רציפה, רמת אמינות מהגבוהות בעולם, עלויות תחזוקה נמוכות ונוחות גבוהה לנהג ולנוסעים. כוללת מערכות בטיחות אקטיביות, מערכת מולטימדיה, בקרת שיוט ותחושת נסיעה חלקה ונעימה. הבחירה הבטוחה לעבודה יומיומית.'
  },
  {
    id: 4,
    model: 'Toyota Corolla Station',
    price: 130000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/stationcc.png',
    slug: 'toyota-corolla-station',
    explanation: 'נפח, נוחות ותועלת\nקורולה סטיישן היא פתרון מושלם למוניות משפחתיות או נסיעות עם הרבה מטען. נפח תא מטען גדול במיוחד, מושבים אחוריים מתקפלים 60/40, מנוע 1.8 ליטר היברידי עם צריכת דלק של עד 22 ק"מ לליטר. אידיאלית להסעות שדה תעופה, שירותי תיירות או משפחות. מצוידת במערכות בטיחות מתקדמות, תאורת LED מלאה, ומערכת עזר לחניה. משדרת יעילות, סדר וניקיון.'
  },
  {
    id: 5,
    model: 'Toyota Corolla Cross',
    price: 145000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/corlla%20cross%20c.png',
    slug: 'toyota-corolla-cross',
    explanation: 'שילוב חכם בין SUV לקומפקט\nדגם קרוס של הקורולה משלב את המרחב של SUV עם החסכון של קורולה. מנוע היברידי מתקדם בנפח 1.8 ליטר, מערכת הנעה קדמית או כפולה (בהתאם לדגם), תצרוכת דלק מדהימה (עד 21 ק"מ לליטר), מושב נהג חשמלי, קישוריות מתקדמת ומערכות בטיחות חכמות. מצוינת לנהגים שמעוניינים ברכב גבוה אך קל לתפעול.'
  },
  {
    id: 6,
    model: 'Toyota CHR',
    price: 135000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/chrc.png',
    slug: 'toyota-chr',
    explanation: 'מראה אורבני, יעילות מקסימלית\nטויוטה C-HR מציגה עיצוב עתידני, קומפקטיות אידיאלית לעיר ויעילות תפעולית גבוהה. מנוע היברידי 1.8 ליטר, תא נוסעים נעים ומפנק, מושבים בעיצוב ספורטיבי, גימור פנימי איכותי. מתאימה במיוחד לנסיעות קצרות בתוך העיר, מוניות צעירות ודינמיות, חווית נהיגה שקטה, בטיחותית ונעימה.'
  },
  {
    id: 7,
    model: 'Toyota Camry',
    price: 185000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/camryc.png',
    slug: 'toyota-camry',
    explanation: 'מונית פרימיום עם נוכחות\nהקאמרי היא סדאן יוקרתית עם מנוע היברידי 2.5 ליטר המספק כ-218 כ"ס, חוויית נהיגה שקטה, יציבה ובטוחה. מושבים מרווחים במיוחד, תא מטען גדול, בידוד רעשים ברמה גבוהה. כוללת מערכת סאונד יוקרתית, מושבים מחוממים, ומערכות בטיחות מהמתקדמות ביותר. מיועדת לנהגי מוניות VIP ולשירותי לקוחות יוקרה, נסיעות מנהלים והסעות לאירועים.'
  },
  {
    id: 8,
    model: 'Toyota Sienna',
    price: 245000,
    image: 'https://storage.googleapis.com/gambot_media_prod/Organizations/autocross2/Templates/siennac.webp',
    slug: 'toyota-sienna',
    explanation: 'המיניוואן שמגדיר מחדש נוחות\nסיינה – הבחירה המושלמת להסעות קבוצתיות. מיניוואן היברידי 2.5 ליטר עם 245 כ"ס, תיבת הילוכים אוטומטית חלקה, 7–8 מושבים נוחים במיוחד, כניסה נוחה, דלתות צד חשמליות, תא מטען עצום, בקרת אקלים תלת-אזורית, מערכות בטיחות מתקדמות כולל שמירה על מרחק, ניטור שטחים מתים ועוד. אידיאלי לשירותי VIP, מוניות לשדה תעופה, חברות תיירות ואירועים משפחתיים.'
  }
]; 